export type UserRole = 'superadmin' | 'admin' | 'editor' | 'viewer';

export const ROLE_RANK: Record<UserRole, number> = {
  viewer: 0,
  editor: 1,
  admin: 2,
  superadmin: 3,
};

export const USER_STATUSES = ['PENDING REVIEW', 'ACTIVE', 'REJECTED', 'SUSPENDED'] as const;

export const USER_STATUS_BADGES: Record<string, { label: string; classes: string }> = {
  ACTIVE: { label: 'Active', classes: 'bg-green-50 text-green-700' },
  'PENDING REVIEW': { label: 'Pending', classes: 'bg-orange-50 text-nside-orange-400' },
  REJECTED: { label: 'Rejected', classes: 'bg-rose-50 text-rose-700' },
  SUSPENDED: { label: 'Suspended', classes: 'bg-gray-100 text-gray-text' },
};

export interface CurrentUser {
  user_id: number;
  org_id: number;
  email: string;
  first_name: string | null;
  last_name: string | null;
  role: UserRole | null;
  status: string;
  /** 'admin' for every staff account (the portal is admin-only). */
  access?: string | null;
}

export interface UserRecord {
  user_id: number;
  org_id: number;
  email: string;
  first_name: string | null;
  last_name: string | null;
  job_title: string | null;
  phone_number: string | null;
  role: UserRole | null;
  status: string;
  org_name: string | null;
  address: string | null;
  city: string | null;
  state: string | null;
  zip: string | null;
}

export interface UserInviteRequest {
  email: string;
  first_name?: string | null;
  last_name?: string | null;
  /** Role the account gets once they register. */
  role: UserRole;
}

export interface UserSelfUpdateRequest {
  first_name: string;
  last_name: string;
  job_title: string | null;
  phone: string;
  address: string | null;
  city: string | null;
  state: string | null;
  zip: string | null;
}

export interface UserAdminUpdateRequest {
  first_name?: string | null;
  last_name?: string | null;
  job_title?: string | null;
  phone_number?: string | null;
  email?: string | null;
  org_id?: number | null;
  role?: string | null;
  status?: string | null;
}
